<template>
  <div class="md-layout">
    <div class="mb-4 md-layout-item md-size-100 md-small-size-100 w-100">
      <button
        class="md-button md-primary md-sm"
        @click="$router.push({ name: 'CreateCategory' })"
        >+ Add Category</button
      >
    </div>

    <div class="md-layout-item md-size-100 mt-4">
      <div class="md-card">
        <div class="md-card-header md-card-header-icon md-card-header-rose">
          <div class="card-icon">
            <i class="material-icons">restaurant</i>
          </div>
          <h4 class="title">Categories</h4>
        </div>
        <div class="md-card-content">
          <table class="table table-full-width">
            <thead>
              <tr>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in categories" :key="item._id">
                <td>{{ item.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {} from "@/components";
import { getAllCategoriesAction } from "@/pages/Categories/actions";

export default {
  components: {},
  created() {
    this.getAll();
  },
  data() {
    return {
      categories: [],
    };
  },
  methods: {
    async getAll() {
      try {
        const response = await getAllAction();
        this.categories = response.categories;
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
  },
};
</script>
